"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _datalist = _interopRequireDefault(require("../datalist"));

var _formatDate = require("../../lib/format-date");

var _formInputs = require("../form-inputs");

var _modal = _interopRequireDefault(require("../modal"));

var _loader = _interopRequireDefault(require("../loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var DashboardUserList = /*#__PURE__*/function (_React$Component) {
  _inherits(DashboardUserList, _React$Component);

  function DashboardUserList(props) {
    var _this;

    _classCallCheck(this, DashboardUserList);

    _this = _possibleConstructorReturn(this, (DashboardUserList.__proto__ || Object.getPrototypeOf(DashboardUserList)).call(this, props));
    _this.state = {
      list: {},
      backendusers: [],
      isLoading: false,
      isBackendUserLoading: false,
      assignModalOpen: false
    };
    _this.loadUsers = _this.loadUsers.bind(_assertThisInitialized(_this));
    _this.columnDateCreate = _this.columnDateCreate.bind(_assertThisInitialized(_this));
    _this.columnUserDetailLink = _this.columnUserDetailLink.bind(_assertThisInitialized(_this));
    _this.columnUser = _this.columnUser.bind(_assertThisInitialized(_this));
    _this.closeAssingModal = _this.closeAssingModal.bind(_assertThisInitialized(_this));
    _this.assignUser = _this.assignUser.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DashboardUserList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.loadUsers();
      this.loadBackendusers(); // do the polling for unchecked farms

      setInterval(function () {
        _this2.loadFarms();
      }, 1000 * 60 * 5);
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$state = this.state,
          list = _this$state.list,
          isLoading = _this$state.isLoading,
          isBackendUserLoading = _this$state.isBackendUserLoading;
      var loading = isLoading || isBackendUserLoading;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, !loading && /*#__PURE__*/_react.default.createElement(_datalist.default, {
        initialData: Object.values(list),
        enableSort: true,
        isLoading: isLoading,
        staticTexts: {
          noData: t('no data'),
          loading: t('loading data')
        },
        columns: [{
          title: '',
          render: this.columnUserDetailLink
        }, {
          title: t('username'),
          prop: 'username'
        }, {
          title: t('last name'),
          prop: 'last_name'
        }, {
          title: t('register date'),
          render: this.columnDateCreate,
          prop: 'date_register'
        }, {
          key: 'assigned',
          title: t('assigned'),
          render: this.columnUser,
          prop: 'assigned_to'
        }],
        initialPageLength: 20,
        keys: ['id'],
        showSearch: false
      }), loading && /*#__PURE__*/_react.default.createElement(_loader.default, {
        size: 'medium'
      }), /*#__PURE__*/_react.default.createElement(_modal.default, {
        backgroundClickClose: true,
        escClose: true,
        closeHandler: this.closeAssingModal,
        id: 'user-assign-modal-user',
        isOpen: this.state.assignModalOpen
      }, /*#__PURE__*/_react.default.createElement(_formInputs.Select, {
        allowAll: true,
        all: t('Nicht Zugewiesen'),
        label: t('Benutzer'),
        list: this.state.backendusers.map(function (user) {
          return {
            id: user.id,
            name: "".concat(user.first_name, " ").concat(user.last_name, " (").concat(user.email, ")")
          };
        }),
        name: 'user',
        t: this.props.t,
        value: this.state.assignModalOpen.backenduser,
        onChange: this.assignUser
      }), /*#__PURE__*/_react.default.createElement("button", {
        type: 'button',
        className: 'btn',
        onClick: this.closeAssingModal
      }, t('close'))));
    }
    /**
     *
     */

  }, {
    key: "loadUsers",
    value: function loadUsers() {
      var _this3 = this;

      this.setState(function (prev) {
        prev.isLoading = true;
      }, function () {
        fetch(_this3.props.loadUserUrl, {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (result) {
          _this3.setState(function (prev) {
            prev.list = result.body.reduce(function (prev, user) {
              prev[user.id] = user;
              return prev;
            }, {});
            prev.isLoading = false;
            return prev;
          });
        }).catch(function (err) {
          void 0;

          _this3.setState(function (prev) {
            prev.isLoading = false;
            return prev;
          });
        });
      });
    }
    /**
     *
     */

  }, {
    key: "loadBackendusers",
    value: function loadBackendusers() {
      var _this4 = this;

      var _this$props$backendUs = this.props.backendUserGroupId,
          backendUserGroupId = _this$props$backendUs === void 0 ? 0 : _this$props$backendUs;
      this.setState(function (prev) {
        prev.isBackendUserLoading = true;
        return prev;
      }, function () {
        fetch("/api/".concat(_this4.props.i18n.language, "/backendusers/group/").concat(backendUserGroupId), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (persons) {
          _this4.setState(function (prev) {
            prev.backendusers = persons;
            prev.isBackendUserLoading = false;
            return prev;
          });
        }).catch(function (err) {
          _this4.setState(function (prev) {
            prev.isBackendUserLoading = false;
            return prev;
          });

          void 0;
        });
      });
    }
    /**
     *
     * @param val
     * @param row
     * @returns {*}
     */

  }, {
    key: "columnUserDetailLink",
    value: function columnUserDetailLink(val, row) {
      var t = this.props.t;
      if (!row.id) return /*#__PURE__*/_react.default.createElement("span", null, "-");
      var href = "/user/".concat(row.id);
      return /*#__PURE__*/_react.default.createElement("a", {
        className: "icon-link",
        href: href,
        title: t('Edit')
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-detail"
      }));
    }
    /**
     *
     * @param val
     * @param row
     * @returns {string}
     */

  }, {
    key: "columnDateCreate",
    value: function columnDateCreate(val, row) {
      return (0, _formatDate.formatDate)(row.date_register);
    }
    /**
     *
     * @param val
     * @param row
     * @returns {*}
     */

  }, {
    key: "columnUser",
    value: function columnUser(val, row) {
      var _this5 = this;

      var t = this.props.t;

      var openModalHandler = function openModalHandler() {
        _this5.setState(function (prev) {
          prev.assignModalOpen = {
            id: row.id,
            backenduser: row.assigned_to
          };
          return prev;
        });
      };

      var userId = parseInt(row.assigned_to),
          noUser = /*#__PURE__*/_react.default.createElement("a", {
        className: "icon-link assigned",
        href: '',
        title: t('Zuweisen'),
        onClick: function onClick(e) {
          e.preventDefault();
          openModalHandler();
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-edit"
      }));

      if (userId === 0) return noUser;
      var user = this.state.backendusers.find(function (user) {
        return parseInt(user.id) === userId;
      });
      if (!user) return noUser;
      return /*#__PURE__*/_react.default.createElement("a", {
        href: '',
        title: t('Zuweisen'),
        onClick: function onClick(e) {
          e.preventDefault();
          openModalHandler();
        }
      }, "".concat(user.last_name));
    }
    /**
     *
     */

  }, {
    key: "closeAssingModal",
    value: function closeAssingModal() {
      this.setState(function (prev) {
        prev.assignModalOpen = false;
        return prev;
      });
    }
    /**
     *
     * @param e
     */

  }, {
    key: "assignUser",
    value: function assignUser(e) {
      var _this6 = this;

      var userId = e.target.value;
      fetch("/api/".concat(this.props.i18n.language, "/administration") + "/user/".concat(this.state.assignModalOpen.id, "/assign"), {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({
          userId: userId
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function (result) {
        _this6.setState(function (prev) {
          if (!prev.assignModalOpen) return prev;
          delete prev.list[_this6.state.assignModalOpen.id];

          if (result && result.body) {
            prev.list[_this6.state.assignModalOpen.id] = result.body.pop();
          }

          prev.assignModalOpen.backenduser = userId;
          return prev;
        });
      }).catch(function (err) {
        void 0;

        _this6.setState(function (prev) {
          if (!prev.assignModalOpen) return prev;
          prev.assignModalOpen.backenduser = '';
          return prev;
        });
      });
    }
  }]);

  return DashboardUserList;
}(_react.default.Component);

DashboardUserList.propTypes = {
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired
  }),
  t: _propTypes.default.func.isRequired,
  loadUserUrl: _propTypes.default.string.isRequired,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string.isRequired
  }),
  backendUserGroupId: _propTypes.default.number
};
var _default = DashboardUserList;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/dashboard-user-list/index.js
// module id = 753
// module chunks = 0